module.exports = __webpack_public_path__ + "static/media/sort-down.d76fd69c.svg";